import { render, staticRenderFns } from "./basket.vue?vue&type=template&id=10df78f4"
import script from "./basket.vue?vue&type=script&lang=js"
export * from "./basket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports